export default {
  PENDING: 1,
  ASSIGNING_DRIVER: 2,
  ON_GOING: 3,
  PICKED_UP: 4,
  COMPLETED: 5,
}
